module.exports = __webpack_public_path__ + "media/images/header-logo-0fe867db4438af541cb348080e111a0d.svg";